<app-breadcrumb [title]="title" [breadcrumbs]="breadcrumbs"></app-breadcrumb>
<app-tangy-forms-player #formPlayer></app-tangy-forms-player>